const Amounts = ["34.50", "85.00", "150.00", "72.50", "224.75", "1148.00"];

const getAmounts = amt => {
  return [...Array(amt).keys()].map(
    n => Amounts[Math.floor(Math.random() * Amounts.length)]
  );
};

export { Amounts, getAmounts };
